import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import InfiniteCalendar, { Calendar, withRange } from 'react-infinite-calendar';
import { withStyles } from '../../../node_modules/@material-ui/core';
import locale from '../Locale';

const CalendarWithRange = withRange(Calendar);

const styles = theme => ({

});

class DatePickerModal extends React.Component {
  handleClose = () => {
    this.props.onClose();
  }

  handleDates = dates => {
    this.props.updatePeriod(dates.start, dates.end);
  }

  render() {
    const { start, end, open } = this.props;

    return (
      <Dialog onClose={() => this.handleClose()} open={open}>
        <InfiniteCalendar
          Component={CalendarWithRange}
          onSelect={this.handleDates}
          width={400}
          height={600}
          selected={{ start, end }}
          locale={locale}
        />
      </Dialog>
    );
  }
}

export default withStyles(styles)(DatePickerModal);


// WEBPACK FOOTER //
// ./src/commons/components/DatePickerModal.jsx